@if (loading()) {
  <div class="home__loading">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
} @else if (loadError()) {
  <div class="home__empty" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ 'home.projects.loadError' | translate }}</span>
  </div>
} @else {
  <div class="home__wrapper">
    <div class="home__page-header">
      <div class="home__page-eyebrow">{{ 'home.welcome.eyebrow' | translate }}</div>
      @if (singleProject(); as project) {
        <h1 class="home__page-title">
          {{ 'home.welcome.singleProject' | translate: { name: project.projectName } }}
        </h1>
      } @else {
        <h1 class="home__page-title">
          {{ 'home.welcome.title' | translate: { name: displayName() } }}
        </h1>
        <p class="home__page-subtitle">{{ 'home.welcome.subtitle' | translate }}</p>
      }
    </div>

    <app-dashboard-page />

    <div class="home__workspaces">
      <to-section-title
        [title]="'home.workspaces.title' | translate"
        [subtitle]="'home.workspaces.subtitle' | translate"
      />

      <div [class]="tileGridClass()">
        @for (tile of tiles(); track tile.link) {
          @if (tile.titleText) {
            <a class="home__single-tile" [routerLink]="tile.link" [attr.aria-label]="tile.titleText">
              <span class="home__single-tile-icon" aria-hidden="true">
                <mat-icon>{{ tile.icon }}</mat-icon>
              </span>
              <span class="home__single-tile-text">
                <span class="home__single-tile-title">{{ tile.titleText }}</span>
                @if (tile.subtitleKey) {
                  <span class="home__single-tile-subtitle">{{ tile.subtitleKey | translate }}</span>
                }
              </span>
            </a>
          } @else if (tile.titleKey && tile.subtitleKey) {
            <app-nav-tile
              [link]="tile.link"
              [icon]="tile.icon"
              [titleKey]="tile.titleKey"
              [subtitleKey]="tile.subtitleKey"
              [statLabelKey]="tile.statLabelKey"
              [statValue]="tile.stat ? tile.stat() : null"
            ></app-nav-tile>
          }
        }
      </div>
    </div>
  </div>
}
<router-outlet></router-outlet>
